/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  imports: [CommonModule],
  selector: 'form-submission-message',
  template: `
    <div *ngIf="showSuccess"
         class="alert alert-success clickable"
         (click)="onDismiss()"
         title="Click to dismiss message">
      <span class="fa fa-times pull-right"></span>
      Your updates were saved successfully
    </div>
  `
})
export class FormSubmissionMessage {
  @Input() validSubmission: boolean;
  @Input() formPristine: boolean;
  /** Supports simple form-state objects when explicit inputs are unavailable. */
  @Input() form: any;
  @Output() dismiss = new EventEmitter<void>();

  get showSuccess(): boolean {
    if (this.validSubmission !== undefined && this.formPristine !== undefined) {
      return this.validSubmission && this.formPristine;
    }
    return !!(this.form?.validSubmission && this.form?.pristine);
  }

  onDismiss(): void {
    if (this.dismiss.observers.length) {
      this.dismiss.emit();
      return;
    }
    if (this.form) {
      this.form.validSubmission = false;
    }
  }
}
